/**
 * Logs de API — backend real.
 *
 * Lee `GET /api/api-log`, el registro server-side de las llamadas salientes a
 * sistemas externos (ERP ACSIS = 'erp', SNT riga = 'snt'). Reemplaza el viejo
 * store client-side (localStorage), que solo se llenaba con los endpoints mock.
 */

import { apiFetch } from '@/api/http';
import type { ApiLogEntry } from '@/domain/types';

interface ApiLogResponse {
  entries: ApiLogEntry[];
  limit: number;
  offset: number;
}

export interface GetApiLogParams {
  sistema?: 'erp' | 'snt';
  estado?: 'ok' | 'error';
  limit?: number;
}

/** Trae las últimas entradas del log de API (default 500, más recientes primero). */
export async function getApiLog(params: GetApiLogParams = {}): Promise<ApiLogEntry[]> {
  const qs = new URLSearchParams();
  if (params.sistema) qs.set('sistema', params.sistema);
  if (params.estado) qs.set('estado', params.estado);
  if (params.limit) qs.set('limit', String(params.limit));
  const suffix = qs.toString() ? `?${qs.toString()}` : '';
  const res = await apiFetch<ApiLogResponse>(`/api-log${suffix}`, { auth: true });
  return res.entries;
}
